import { useContext, useEffect, useRef, useState } from 'react';
import { Bell, ChevronDown, List } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../assets/css/vendors/HotelComponents/hotelHeader.css';
import AppContext from '../../context/AppContext';

const HotelHeader = ({ isMobile, isSidebarOpen, onToggleSidebar, isCollapsed }) => {  const navigate = useNavigate();
  const { vendorloggedin, setAuthToken, storeActiveSidebar, baseUrl, authToken, vendorId } = useContext(AppContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef(null);

  const [vendorName, setVendorName] = useState(() =>
    localStorage.getItem('vendorName') || localStorage.getItem('userName') || ''
  );
  const [vendorEmail, setVendorEmail] = useState(() =>
    localStorage.getItem('vendorEmail') || ''
  );

  const getInitials = (name) => {
    if (!name || name.trim() === '') return '?';
    return name.trim().split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setVendorName(
        localStorage.getItem('vendorName') || localStorage.getItem('userName') || ''
      );
      setVendorEmail(localStorage.getItem('vendorEmail') || '');
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  useEffect(() => {
    if (!vendorId) return;

    axios
      .get(`${baseUrl}/vendor/notifications`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { vendor_id: vendorId },
      })
      .then((res) => {
        const notifications = res.data?.data || [];
        setUnreadCount(notifications.filter((n) => n.status !== 'read').length);
      })
      .catch(() => setUnreadCount(0));
  }, [baseUrl, authToken, vendorId]);

  const handleLogout = () => {
    localStorage.removeItem('vendorEmail');
    localStorage.removeItem('vendorPassword');
    localStorage.removeItem('vendorName');
    localStorage.removeItem('vendorRole');
    localStorage.removeItem('vendorId');
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('hotelId');
    localStorage.removeItem('userName');
    vendorloggedin();
    setAuthToken(null);
    setShowDropdown(false);
    navigate('/auth/login'); 
  };

  const handleProfileNavigate = () => {
    setShowDropdown(false);
    storeActiveSidebar('profile-settings');
    navigate('/vendor/settings/hotel-profile-settings');
  };

  const handleSettingsNavigate = () => {
    setShowDropdown(false);
    storeActiveSidebar('settings');
    navigate('/vendor/settings/hotel-settings');
  };

  const handleNotificationNavigate = () => {
    storeActiveSidebar('notifications');
    navigate('/vendor/hotel-notification');
  };

  return (
<div className={`ven-hdr-container ${!isMobile && isCollapsed ? 'ven-hdr-collapsed' : ''}`}>
        <div className="ven-hdr-inner">

        {/* Left: hamburger + title */}
        <div className="ven-hdr-left">
          {isMobile && (
            <button
              className="ven-hdr-mobile-btn"
              onClick={onToggleSidebar}
              aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'}
            >
              <List size={24} />
            </button>
          )}
          <h1 className="ven-hdr-title">Hotel Panel</h1>
        </div>

        <div className="ven-hdr-actions">
        <button
          className="ven-hdr-notification-btn"
          onClick={handleNotificationNavigate}
          aria-label="Notifications"
        >
          <Bell size={20} />
          {unreadCount > 0 && (
            <span className="ven-hdr-notification-badge">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>

        <div className="ven-hdr-profile-wrap" ref={dropdownRef}>
          <button
            className="ven-hdr-profile-btn"
            onClick={() => setShowDropdown(prev => !prev)}
          >
            <div className="ven-hdr-avatar">
              <span className="ven-hdr-avatar-initials">{getInitials(vendorName)}</span>
              <span className="ven-hdr-avatar-online" />
            </div>

            <div className="ven-hdr-user-info d-none d-md-block">
              <span className="ven-hdr-user-name">{vendorName}</span>
              {vendorEmail && (
                <span className="ven-hdr-user-email">{vendorEmail}</span>
              )}
            </div>

            <ChevronDown
              size={15}
              className={`ven-hdr-chevron ${showDropdown ? 'ven-hdr-chevron-open' : ''}`}
            />
          </button>

          {showDropdown && (
            <div className="ven-hdr-dropdown">

              <div className="ven-hdr-dropdown-header">
                <div className="ven-hdr-dd-avatar">
                  <span className="ven-hdr-avatar-initials">{getInitials(vendorName)}</span>
                </div>
                <div>
                  <p className="ven-hdr-dd-name">{vendorName}</p>
                  <p className="ven-hdr-dd-email">{vendorEmail || 'No email found'}</p>
                </div>
              </div>

              <div className="ven-hdr-dropdown-divider" />

              <button className="ven-hdr-dd-item" onClick={handleProfileNavigate}>
                Profile Settings
              </button>

              <button className="ven-hdr-dd-item" onClick={handleSettingsNavigate}>
                Settings
              </button>

              <div className="ven-hdr-dropdown-divider" />

              <button className="ven-hdr-dd-item ven-hdr-dd-logout" onClick={handleLogout}>
                Logout
              </button>

            </div>
           )}
         </div>
        </div>

      </div>
    </div>
  );
};

export default HotelHeader;
